import React, { Component } from 'react';

const pinIcon = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
  </svg>
);

const alertIcon = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-13h2v6h-2zm0 8h2v2h-2z" />
  </svg>
);

export default class TicketItems extends Component {
  render() {
    const data = this.props.data;
    if (!data) return null;
    const cancelled = !this.props.isCancellable(data);
    const location = data.location || data.arena_name || data.address || '';
    const name = [data.first_name, data.last_name].filter(Boolean).join(' ');
    const amount = data.rental_fee ? '$' + (data.rental_fee / 100).toFixed(2) : '';

    return (
      <div className={'sub-card' + (cancelled ? ' is-cancelled' : '')}>
        <div className="sub-card__head">
          <div className="sub-card__icon">{pinIcon}</div>
          <div className="sub-card__where">
            <div className="sub-card__eyebrow">Parking location</div>
            <div className="sub-card__location">{location}</div>
          </div>
          <span className={'pill ' + (cancelled ? 'pill--cancelled' : 'pill--active')}>
            {cancelled ? 'Cancelled' : 'Active'}
          </span>
        </div>
        {this.props.length > 1 && !cancelled && (
          <label className="check-row">
            <input type="checkbox" checked={!!data.selected} onChange={() => this.props.manageSelectedTickets(data.id)} />
            Include this pass in the cancellation
          </label>
        )}
        <ul className="sub-card__rows">
          {data.account_name && <li><span className="k">Account Name</span><span className="v">{data.account_name}</span></li>}
          <li><span className="k">Name</span><span className="v">{name}</span></li>
          <li><span className="k">Pass Type</span><span className="v">{data.pass_type}</span></li>
          <li><span className="k">Vehicle No.</span><span className="v"><span className="chip">{data.vehicle_no}</span></span></li>
          <li><span className="k">Amount</span><span className="v">{amount} {amount && <small>/ month</small>}</span></li>
          <li><span className="k">Validity Start</span><span className="v">{data.validity_start_time}</span></li>
          <li><span className="k">Validity End</span><span className="v">{data.validity_end_time}</span></li>
        </ul>
        {cancelled && (
          <div className="sub-card__banner">
            {alertIcon}
            <span>{this.props.cancelledText(data)}</span>
          </div>
        )}
      </div>
    );
  }
}
